import { render, staticRenderFns } from "./editFoodStatus.vue?vue&type=template&id=4a99ce10&scoped=true&"
import script from "./editFoodStatus.vue?vue&type=script&lang=js&"
export * from "./editFoodStatus.vue?vue&type=script&lang=js&"
import style0 from "./editFoodStatus.vue?vue&type=style&index=0&id=4a99ce10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a99ce10",
  null
  
)

export default component.exports